<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  mounted() {
    const computeZoom = (width, height, width1, height1) => {
      var scale = height1 / width1,
        res = height / width > scale ? height / height1 : width / width1;
      console.log(res);
      return res;
    };
    const handleResize = () => {
      const userAgent = navigator.userAgent;
      const mobileRegex =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i;

      if (!mobileRegex.test(userAgent)) {
        let timeout = null;
        timeout && clearTimeout(timeout);
        timeout = setTimeout(() => {
          var zoom = computeZoom(innerWidth, innerHeight, 1920, 1080);
          document.body.style.cssText = "zoom:" + zoom;
        });
      }
    };
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      // if (timeintival.current) {
      //   clearInterval(timeintival.current)
      // }
    };
  },
};
</script>

<style>
</style>